module.exports = __webpack_public_path__ + "static/AMA20 Finalist Medal_Broker of the Year - Commercial-14ec9a15d08754a9b8708740d841a3b2.png";